import { z } from 'zod';

import { BorrowerId, LoanId } from '../BrandedIds';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const DisableRepayAccountSideEffectContext = BaseLoanIdSideEffect.extend({
  loanId: LoanId,
  borrowerId: BorrowerId,
  repayAccountId: z.string(),
  failureCode: z.string(),
});

export const DisableRepayAccountSideEffect = DisableRepayAccountSideEffectContext.extend({
  type: z.literal('disableRepayAccount'),
});
export type DisableRepayAccountSideEffect = z.infer<typeof DisableRepayAccountSideEffect>;
